<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button aria-label="FAQ actions" size="icon-sm" variant="ghost" :disabled="isDeleting">
        <MoreHorizontal class="rotate-90" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" class="w-36">
      <DropdownMenuItem :disabled="isDeleting" @click="emit('edit')">
        Edit
      </DropdownMenuItem>
      <DropdownMenuItem :disabled="isDeleting" class="text-destructive" @click="handleDelete">
        {{ isDeleting ? 'Deleting...' : 'Delete' }}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup>
import { MoreHorizontal } from 'lucide-vue-next'
import { Button } from '../../../../../../../resources/js/components/ui/button/index.js'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../../../../../resources/js/components/ui/dropdown-menu/index.js'

const props = defineProps({
  isDeleting: {
    type: Boolean,
    default: false,
  },
  question: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['edit', 'delete'])

const handleDelete = () => {
  const shouldDelete = confirm(`Delete FAQ "${props.question || 'this item'}"?`)

  if (!shouldDelete) {
    return
  }

  emit('delete')
}
</script>
